import cloneDeep from 'lodash/cloneDeep';
import { generateId } from './id';

/**
 * Build a fresh block instance from its definition (uses field defaults).
 * Returns `{ type, settings }` — caller adds `id`.
 * Returns `null` if no definition.
 */
export function createBlock(type, blockSchema) {
  if (!blockSchema) return null;
  const settings = {};
  for (const field of blockSchema.settings ?? []) {
    if (field.id && field.default !== undefined) {
      settings[field.id] = field.default;
    }
  }
  return { type, settings };
}

/** Deep-clone a block and regenerate its id. */
export function cloneBlock(block) {
  return { ...cloneDeep(block), id: generateId(block.type) };
}
